import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-flag-fr",
  "use": "icon-flag-fr-usage",
  "viewBox": "0 0 1532 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1532 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-flag-fr\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 1024V0h1532.896045v1024z m1529.741205-3.137878zM6.360565 1017.656397h1520.174915V6.258795H6.360565z\" fill=\"#231F20\" p-id=\"15988\" /><path d=\"M3.239648 3.205725h508.794275v1017.656397H3.239648z\" fill=\"#002F66\" p-id=\"15989\" /><path d=\"M512.033923 3.205725h508.862122v1017.656397H512.033923z\" fill=\"#FFFFFF\" p-id=\"15990\" /><path d=\"M1020.896045 3.205725h508.862121v1017.656397H1020.896045z\" fill=\"#EF4135\" p-id=\"15991\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/flag-fr.svg
// module id = zIor
// module chunks = 24